import uberfetch from 'uberfetch';
import hasRequestCapability from 'ca-environment/hasRequestCapability';
import handleGenericAppErrors from './handleGenericAppErrors';
const wrapJQueryRequest = require('ca-request/wrapJQueryRequest').default;

function addAdditionalOpts(
  opts: { headers?: Record<string, string | string[] | undefined> } = {}
) {
  const existingHeaders = opts.headers || {};
  const headers = {
    'X-Requested-With': 'XMLHttpRequest',
    ...existingHeaders,
  };

  return { ...opts, headers };
}

function makeRequestFn(originalRequestFn: typeof uberfetch.get) {
  return async (
    url: Parameters<typeof uberfetch>[0],
    opts?: Parameters<typeof uberfetch>[1]
  ) => {
    if (!hasRequestCapability()) {
      throw new Error(
        `Cannot make app requests in this environment.
        url: ${url}
        opts: ${JSON.stringify(opts)}`
      );
    }
    return originalRequestFn(url, addAdditionalOpts(opts)).catch(
      handleGenericAppErrors
    );
  };
}

// Use this module for making requests to the app
// use uberfetch directly for making requests to external APIs
const request = Object.assign(makeRequestFn(uberfetch), {
  get: makeRequestFn(uberfetch.get),
  post: makeRequestFn(uberfetch.post),
  put: makeRequestFn(uberfetch.put),
  delete: makeRequestFn(uberfetch.delete),
  RequestError: uberfetch.RequestError,
  handleGenericAppErrors,
  wrapJQueryRequest,
});

export default request;
